export const COOKIE_BANNER_OPENER = 'COOKIE_BANNER_OPENER';

export default COOKIE_BANNER_OPENER;
